import moment from 'moment'

export default {
    state: {
        summaryDate: [
            {
                name: 'Data Inicial',
                value: moment(new Date(new Date().setMonth(new Date().getMonth() - 1))).format('DD/MM/YYYY'),
                // value: moment(new Date(new Date().setFullYear(new Date().getFullYear() - 5))).format('DD/MM/YYYY'),
                format: 'date',
                type: 'DTINI'
            },
            {
                name: 'Data Final',
                value: moment(new Date()).format('DD/MM/YYYY'),
                format: 'date',
                type: 'DTFIM'
            }
        ],
        periodSelectionMenu: {
            isVisible: false
        },
        dateModal: {
            isVisible: false,
            text: ''
        }
    },
    mutations: {
        setPeriodSelectionMenuVisibility (state) {
            state.periodSelectionMenu.isVisible = !state.periodSelectionMenu.isVisible
        },
        showDateModal (state, data) {
            state.dateModal.text = data.text
            state.dateModal.isVisible = true
        },
        closeDateModal  (state) {
            state.dateModal.isVisible = false
        }
    },
    actions: {
        changePeriodSelectionMenuVisibility ({ commit }) {
            commit('setPeriodSelectionMenuVisibility')
        },
        showDateModal ({ commit }, data) {
            commit('showDateModal', data)
        },
        closeDateModal ({ commit }) {
            commit('closeDateModal')
        }
    },
    getters: {
        getSummaryDate: (state) => state.summaryDate,
        // getFormatedSummaryData: (state) => {
        //     const formatData = Object.assign(state.summaryData, [])
        //     formatData[0].value = formatData[0].value.toLocaleDateString('pt-BR')
        //     formatData[1].value = formatData[1].value.toLocaleDateString('pt-BR')
        //     return formatData
        // },
        // getDTINIDTFIM: (state) => {
        //     debugger
        //     return {
        //         DTINI: state.summaryData[0].value.toLocaleDateString('pt-BR'),
        //         DTFIM: state.summaryData[1].value.toLocaleDateString('pt-BR')
        //     }
        // },
        periodSelectionMenu: (state) => state.periodSelectionMenu,
        dateModal: (state) => state.dateModal
    }
}
